import React, { Component, Fragment } from 'react';
import SubMenu from './SubMenu';
import cx from 'classnames';

class LinkWithChildren extends Component {
  constructor() {
    super();
    this.state = {
      expand: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSubMenuClick = this.handleSubMenuClick.bind(this);
    this.updateLink = this.updateLink.bind(this);
  }

  //this only handles the header therefore not propagating out of the class
  handleClick() {
    this.setState(prevState => {
      return {
        expand: !prevState.expand,
      };
    });
  }

  handleSubMenuClick(item) {
    this.props.handleClick(item);
  }

  componentDidMount() {
    this.updateLink(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.updateLink(nextProps);
  }

  updateLink(props) {
    const { item, selectedSubMenuId } = props;

    this.setState({
        expand: item.content.find(x => x.id === selectedSubMenuId)
    });
  }

  render() {
    const { item } = this.props;
    const { expand } = this.state;

    const caretStyle = curr =>
      cx({
        mcaret: curr.content,
        'mcaret-plus': curr.content && expand,
        'mcaret-minus': curr.content && expand,
      });

    const subMenuStyle = curr =>
      cx({
        'sub-menu': true,
        'sub-menu-visible': expand,
      });

    return (
      <Fragment>
        <a onClick={this.handleClick}>
          <span className="micron">
            <i className={`ti-${item.icon}`} />
          </span>
          <span className="mtext">{item.label}</span>
          <span className={caretStyle(item)} />
        </a>
        {item.content && (
          <ul className={subMenuStyle(item)}>
            {item.content.map((sub, j) => (
              <SubMenu item={sub} key={j} handleClick={this.handleSubMenuClick} />
            ))}
          </ul>
        )}
      </Fragment>
    );
  }
}

export default LinkWithChildren;
